<nav class="layout-breadcrumb" style="padding-left: 2rem;">
  <span class="viewname" style="text-transform: uppercase;cursor: pointer;"> <a><i routerLink="/accueil" class="pi pi-home" style="font-size: 1.25rem"></i></a></span>
  <ng-container *ngFor="let item of (breadcrumbs$ | async); let last = last">
      <span class="viewname" *ngIf="item.parentLabel" style="text-transform: uppercase;font-size: 1rem;"> /  {{item.parentLabel}}</span>
      <span class="viewname" *ngIf="item.url" style="text-transform: uppercase;font-size: 1rem;"> /  <a [routerLink]="['/' + item.url]">{{ item.label }}</a></span>
      <span class="viewname" *ngIf="!item.url" style="text-transform: uppercase;font-size: 1rem;"> /  {{ item.label }} </span>
  </ng-container>
</nav>
